import React, { Component, Fragment } from 'react'
import { Tabs, Loader } from '@driftt/tide-core'
import { Div } from '@driftt/tide-core'
import { equals } from 'ramda'

import { getEmailCampaignReport } from 'api/campaigns'
import EmailPerformance from 'components/Reports/EmailPerformance/EmailPerformanceTab'
import CampaignPeopleTab from 'components/Reports/EmailPerformance/PeopleTab/CampaignPeopleTab'

import '../../PlaybookReports/styles.css'

class EmailReport extends Component {
  constructor(props) {
    super(props)

    this.state = {
      totalStats: null,
      campaign: null,
      isLoading: true,
    }
  }

  componentDidMount() {
    this.getCampaignStats()
  }

  componentDidUpdate(prevProps) {
    if (!equals(this.props, prevProps)) {
      this.setState({ isLoading: true, totalStats: null })
      this.getCampaignStats()
    }
  }

  getCampaignStats = async () => {
    const { currentDateRange, previousDateRange, campaign } = this.props
    const { id } = campaign
    const [ startDate, endDate ] = currentDateRange
    const [ prevStartDate, prevEndDate ] = previousDateRange
    try {
      const { data } = await getEmailCampaignReport(id, { startDate, endDate, prevStartDate, prevEndDate })
      this.setState({ totalStats: data, isLoading: false })
    } catch (error) {
      console.log(error)
    }
  }

  render() {
    const { totalStats, isLoading } = this.state
    const { campaign, currentDateRange, previousDateRange } = this.props
    const campaignID = campaign.id

    const TAB_GROUP = [{
      title: 'Performance',
      component: () => <EmailPerformance
                          id={campaignID}
                          data={totalStats}
                          campaign={campaign}
                          dateRanges={{current: currentDateRange, previous: previousDateRange}}
                        />
      },
      {
        title: 'People',
        component: () => <CampaignPeopleTab
                            id={campaignID}
                            campaign={campaign}
                            dates={currentDateRange}
                          />
      }]

    return (
      <Div className="playbook-reports-content-container">
        {isLoading ?
          <Div className="playbook-report-loader">
            <Loader height={200} width={200} />
          </Div> :
          <Fragment>
            <Tabs data={TAB_GROUP} activeTab={0} />
          </Fragment>
        }
      </Div>
    )
  }
}

export default EmailReport
